import React from 'react';
import MyAccount from './MyAccount/MyAccount';
import History from './History/History';
import Transactions from './Transactions/Transactions';

import IconMyAccount from './assets/images/myaccount-icon.svg?inline';
import IconHistory from './assets/images/history-icon.svg?inline';
import IconTransactions from './assets/images/transactions-icon.svg?inline';

export const basePath = '/account';
export const routes = [
  {
    label: 'My Account',
    path: '',
    component: <MyAccount />,
    icon: <IconMyAccount />,
  },
  {
    label: 'Game History',
    path: '/history',
    component: <History />,
    icon: <IconHistory />,
  },
  {
    label: 'Transactions',
    path: '/transactions',
    component: <Transactions />,
    icon: <IconTransactions />,
  },
];
